"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTopicsList = exports.TopicIdSchema = void 0;
const zod_1 = require("zod");
exports.TopicIdSchema = zod_1.z.string();
const TopicsListSchema = zod_1.z.array(exports.TopicIdSchema);
const validateTopicsList = (x) => TopicsListSchema.safeParse(x);
exports.validateTopicsList = validateTopicsList;
//# sourceMappingURL=topic_types.js.map